import { useQuery } from "@tanstack/react-query";
import { getBranchAccessPermissions } from "apis/auth/permissions_api";
import { permissionsKeys } from "apis/auth/query_keys_auth";
import { restEmpty, simpleAlert } from "components/CommonLib/CommonLib";
import { useDispatch } from "react-redux";

// [GET] 지점 접근 권한 가져오기
export const useGetBranchAccessPermissions = (authCode, includeBranchAll) => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: permissionsKeys.branchAccess(),
    queryFn: () => getBranchAccessPermissions(authCode),
    enabled: true,
    retry: false,
    cacheTime: 0,

    select: (data) => {
      if (restEmpty(data.data.data)) {
        return null;
      }
      const result = data.data.data;

      // hq_name 기준으로 정렬
      result.sort((a, b) => (a.hq_info.hq_name > b.hq_info.hq_name ? 1 : -1));

      // hq_name만 추출한 리스트 생성
      const hq_list = result.map((item) => item.hq_info.hq_name);

      // branch_name_list 각 객체에 추가
      result.forEach((item) => {
        if (includeBranchAll) {
          // 전체 옵션 여부 확인
          const hasAllOption = item.branch_list.some((branch) => branch.branch_name === "전체");

          if (!hasAllOption) {
            const branchIds = item.branch_list.map((branch) => branch.branch_id);
            const branchAllInfo = { branch_name: "전체", branch_ids: branchIds };
            item.branch_list.unshift(branchAllInfo);
          }
        }
        const branchNames = item.branch_list.map((branch) => branch.branch_name);

        item.branch_name_list = branchNames;
      });

      return {
        data: result,
        hq_list: hq_list,
      };
    },
    onSuccess: (res) => {
      if (res === null) {
        simpleAlert(
          storesDispatch,
          "알림",
          "페이지를 표시할 수 없습니다.\n잠시 후 다시 시도해주세요.",
          true,
          () => {
            window.location.href = "/";
          },
        );
      } else if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },

    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};
